import config from '@/config'
import store from '@/store'

export default [
  {
    path: '/',
    name: 'index',
    redirect: () => ({ name: config.defaultRoute[store.state.user.meta.group] })
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      auth: [config.groups.PUBLIC]
    },
    component: () => import(/* webpackChunkName: "v-login" */ '@/views/VLogin')
  },
  {
    path: '/registrierung',
    name: 'signup',
    meta: {
      auth: [config.groups.PUBLIC]
    },
    component: () => import(/* webpackChunkName: "v-signup" */ '@/views/VSignup')
  },
  {
    path: '/registrierung/konto-erstellt',
    name: 'signup-created',
    meta: {
      auth: [config.groups.PUBLIC]
    },
    component: () => import(/* webpackChunkName: "v-signup" */ '@/views/VSignupCreated')
  },
  {
    path: '/registrierung/bestaetigen/:token',
    name: 'signup-confirm',
    meta: {
      auth: [config.groups.PUBLIC]
    },
    component: () => import(/* webpackChunkName: "v-signup-confirm" */ '@/views/VSignupConfirm'),
    props: route => ({
      token: route.params.token
    }),
    beforeEnter: (to, from, next) => {
      if (!to.params.token) {
        return next({ name: 'login', replace: true })
      }

      next()
    }
  },
  {
    path: '/registrierung/profil-anlegen',
    name: 'signup-profile',
    meta: {
      auth: [config.groups.NEW]
    },
    component: () => import(/* webpackChunkName: "v-signup-profile" */ '@/views/VSignupProfile')
  },
  {
    path: '/registrierung/ausstehend',
    name: 'signup-pending',
    meta: {
      auth: [config.groups.COACH, config.groups.COACHEE]
    },
    component: () => import(/* webpackChunkName: "v-signup-profile" */ '@/views/VSignupPending')
  },
  {
    path: '/passwort/vergessen',
    name: 'password-forgotten',
    meta: {
      auth: [config.groups.PUBLIC]
    },
    component: () => import(/* webpackChunkName: "v-password-forgotten" */ '@/views/VPasswordForgotten')
  },
  {
    path: '/passwort/ausstehend',
    name: 'password-pending',
    meta: {
      auth: [config.groups.PUBLIC]
    },
    component: () => import(/* webpackChunkName: "v-password-forgotten" */ '@/views/VPasswordPending')
  },
  {
    path: '/passwort/setzen/:token',
    name: 'password-set-new',
    meta: {
      auth: [config.groups.PUBLIC]
    },
    component: () => import(/* webpackChunkName: "v-password-set-new" */ '@/views/VPasswordSetNew'),
    props: route => ({
      token: route.params.token
    }),
    beforeEnter: (to, from, next) => {
      if (!to.params.token) {
        return next({ name: 'login', replace: true })
      }

      next()
    }
  },
  {
    path: '/konto',
    name: 'account',
    meta: {
      auth: [config.groups.ADMIN, config.groups.COACH, config.groups.COACHEE]
    },
    component: () => import(/* webpackChunkName: "v-account" */ '@/views/VAccount')
  },
  {
    path: '/konto/passwort',
    name: 'account-password',
    meta: {
      auth: [config.groups.ADMIN, config.groups.COACH, config.groups.COACHEE]
    },
    component: () => import(/* webpackChunkName: "v-account-password" */ '@/views/VAccountPassword')
  },
  {
    path: '/konto/loeschen',
    name: 'account-delete',
    meta: {
      auth: [config.groups.COACH, config.groups.COACHEE]
    },
    component: () => import(/* webpackChunkName: "v-account-delete" */ '@/views/VAccountDelete')
  },
  {
    path: '/registrierungen',
    name: 'registration-list',
    meta: {
      auth: [config.groups.ADMIN]
    },
    component: () => import(/* webpackChunkName: "v-registration-list" */ '@/views/VRegistrationList')
  },
  {
    path: '/coach/liste',
    name: 'coach-list',
    meta: {
      auth: [config.groups.ADMIN, config.groups.COACHEE]
    },
    component: () => import(/* webpackChunkName: "v-coach" */ '@/views/VCoachList')
  },
  {
    path: '/coach/detail/:id',
    name: 'coach-detail',
    meta: {
      auth: [config.groups.ADMIN, config.groups.COACHEE]
    },
    component: () => import(/* webpackChunkName: "v-coach" */ '@/views/VCoachDetail'),
    props: route => ({
      id: parseInt(route.params.id)
    }),
    beforeEnter: (to, from, next) => {
      if (!to.params.id) {
        return next({ name: 'coach-list', replace: true })
      }

      next()
    }
  },
  {
    path: '/coach/einladen/:id',
    name: 'coach-invitation',
    meta: {
      auth: [config.groups.COACHEE]
    },
    component: () => import(/* webpackChunkName: "v-coach-invitation" */ '@/views/VCoachInvitation'),
    props: route => ({
      id: parseInt(route.params.id)
    }),
    beforeEnter: (to, from, next) => {
      if (!to.params.id) {
        return next({ name: 'coach-list', replace: true })
      }

      next()
    }
  },
  {
    path: '/coachee/liste',
    name: 'coachee-list',
    meta: {
      auth: [config.groups.ADMIN]
    },
    component: () => import(/* webpackChunkName: "v-coachee" */ '@/views/VCoacheeList')
  },
  {
    path: '/coachee/detail/:id',
    name: 'coachee-detail',
    meta: {
      auth: [config.groups.ADMIN]
    },
    component: () => import(/* webpackChunkName: "v-coachee" */ '@/views/VCoacheeDetail'),
    props: route => ({
      id: parseInt(route.params.id)
    }),
    beforeEnter: (to, from, next) => {
      if (!to.params.id) {
        return next({ name: 'coachee-list', replace: true })
      }

      next()
    }
  },
  {
    path: '/coaching/liste',
    name: 'coaching-list',
    meta: {
      auth: [config.groups.ADMIN, config.groups.COACH, config.groups.COACHEE]
    },
    component: () => import(/* webpackChunkName: "v-coaching" */ '@/views/VCoachingList')
  },
  {
    path: '/coaching/detail/:id',
    name: 'coaching-detail',
    meta: {
      auth: [config.groups.ADMIN, config.groups.COACH, config.groups.COACHEE]
    },
    component: () => import(/* webpackChunkName: "v-coaching" */ '@/views/VCoachingDetail'),
    props: route => ({
      id: parseInt(route.params.id)
    }),
    beforeEnter: (to, from, next) => {
      if (!to.params.id) {
        return next({ name: 'coaching-list', replace: true })
      }

      next()
    }
  },
  {
    path: '/sitzung/detail/:id',
    name: 'session-detail',
    meta: {
      auth: [config.groups.ADMIN, config.groups.COACH, config.groups.COACHEE]
    },
    component: () => import(/* webpackChunkName: "v-session" */ '@/views/VSessionDetail'),
    props: route => ({
      id: parseInt(route.params.id)
    }),
    beforeEnter: (to, from, next) => {
      if (!to.params.id) {
        return next({ name: 'coaching-list', replace: true })
      }

      next()
    }
  },
  {
    path: '*',
    redirect: { name: 'index' }
  }
]
